import React from "react";
import { connect } from "react-redux";
import ModalView from "./ModelView";

class TermsAndConditions extends React.Component {
  state = {
    termsOpen: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.termsAccepted !== this.props.termsAccepted) {
      this.setState({ termsOpen: false });
    }
  }
  render() {
    const { readOnly, validationErrors, termsAccepted, onChange, children } =
      this.props;

    return (
      <label className="auth-checkbox">
        <input
          type="checkbox"
          name="termsAccepted"
          readOnly={readOnly}
          onChange={onChange}
          checked={readOnly || termsAccepted}
        />
        <span className="ms-1">Accept</span>
        <button
          type="button"
          className="terms-link"
          onClick={() => this.setState({ termsOpen: true })}
        >
          Licensing Terms and Conditions
        </button>
        <div className="validation-error">{validationErrors.termsAccepted}</div>
        <ModalView
          setModal={() => this.setState({ termsOpen: !this.state.termsOpen })}
          isOpen={this.state.termsOpen}
        >
          {children}
        </ModalView>
      </label>
    );
  }
}

const mapStateToProps = ({ errors: { validationErrors } }) => ({
  validationErrors,
});

export default connect(mapStateToProps)(TermsAndConditions);
